import _definePage_default_0 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/campaigns/cdn-campaign-url.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/dashboard.vue?definePage&vue'
import _definePage_default_3 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/hyper-speed/index.vue?definePage&vue'
import _definePage_default_4 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/login.vue?definePage&vue'
import _definePage_default_5 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/meeting-rooms/index.vue?definePage&vue'
import _definePage_default_6 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/auto-migration/index.vue?definePage&vue'
import _definePage_default_7 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/channels/index.vue?definePage&vue'
import _definePage_default_8 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/index.vue?definePage&vue'
import _definePage_default_9 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/[id].vue?definePage&vue'
import _definePage_default_10 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/crema-brands/index.vue?definePage&vue'
import _definePage_default_11 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/data/index.vue?definePage&vue'
import _definePage_default_12 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/download-driver/index.vue?definePage&vue'
import _definePage_default_13 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/index.vue?definePage&vue'
import _definePage_default_14 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/create.vue?definePage&vue'
import _definePage_default_15 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/image-size/index.vue?definePage&vue'
import _definePage_default_16 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/mapping-manager/index.vue?definePage&vue'
import _definePage_default_17 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/report/index.vue?definePage&vue'
import _definePage_default_18 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scan/index.vue?definePage&vue'
import _definePage_default_19 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scanner/index.vue?definePage&vue'
import _definePage_default_20 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/tasks/index.vue?definePage&vue'
import _definePage_default_21 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload/index.vue?definePage&vue'
import _definePage_default_22 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload-driver/index.vue?definePage&vue'
import _definePage_default_23 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/utility/index.vue?definePage&vue'

export const routes = [
  {
    path: '/campaigns',
    /* internal name: 'campaigns' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'cdn-campaign-url',
        name: 'campaigns-cdn-campaign-url',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/campaigns/cdn-campaign-url.vue'),
        /* no children */
      },
  _definePage_default_0
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/dashboard.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/hyper-speed',
    /* internal name: 'hyper-speed' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'hyper-speed',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/hyper-speed/index.vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/login.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  {
    path: '/meeting-rooms',
    /* internal name: 'meeting-rooms' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'meeting-rooms',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/meeting-rooms/index.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  {
    path: '/review',
    /* internal name: 'review' */
    /* no component */
    children: [
      {
        path: 'auto-migration',
        /* internal name: 'review-auto-migration' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-auto-migration',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/auto-migration/index.vue'),
            /* no children */
          },
  _definePage_default_6
  )
        ],
      },
      {
        path: 'channels',
        /* internal name: 'review-channels' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-channels',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/channels/index.vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      },
      {
        path: 'client',
        /* internal name: 'review-client' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-client',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/index.vue'),
            /* no children */
          },
  _definePage_default_8
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'review-client-id',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/[id].vue'),
            /* no children */
          },
  _definePage_default_9
  )
        ],
      },
      {
        path: 'crema-brands',
        /* internal name: 'review-crema-brands' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-crema-brands',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/crema-brands/index.vue'),
            /* no children */
          },
  _definePage_default_10
  )
        ],
      },
      {
        path: 'data',
        /* internal name: 'review-data' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-data',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/data/index.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      },
      {
        path: 'download-driver',
        /* internal name: 'review-download-driver' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-download-driver',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/download-driver/index.vue'),
            /* no children */
          },
  _definePage_default_12
  )
        ],
      },
      {
        path: 'estimates',
        /* internal name: 'review-estimates' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-estimates',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/index.vue'),
            /* no children */
          },
  _definePage_default_13
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'review-estimates-create',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/create.vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      },
      {
        path: 'image-size',
        /* internal name: 'review-image-size' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-image-size',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/image-size/index.vue'),
            /* no children */
          },
  _definePage_default_15
  )
        ],
      },
      {
        path: 'mapping-manager',
        /* internal name: 'review-mapping-manager' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-mapping-manager',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/mapping-manager/index.vue'),
            /* no children */
          },
  _definePage_default_16
  )
        ],
      },
      {
        path: 'report',
        /* internal name: 'review-report' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-report',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/report/index.vue'),
            /* no children */
          },
  _definePage_default_17
  )
        ],
      },
      {
        path: 'scan',
        /* internal name: 'review-scan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-scan',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scan/index.vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      },
      {
        path: 'scanner',
        /* internal name: 'review-scanner' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-scanner',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scanner/index.vue'),
            /* no children */
          },
  _definePage_default_19
  )
        ],
      },
      {
        path: 'tasks',
        /* internal name: 'review-tasks' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-tasks',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/tasks/index.vue'),
            /* no children */
          },
  _definePage_default_20
  )
        ],
      },
      {
        path: 'upload',
        /* internal name: 'review-upload' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-upload',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload/index.vue'),
            /* no children */
          },
  _definePage_default_21
  )
        ],
      },
      {
        path: 'upload-driver',
        /* internal name: 'review-upload-driver' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-upload-driver',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload-driver/index.vue'),
            /* no children */
          },
  _definePage_default_22
  )
        ],
      }
    ],
  },
  {
    path: '/utility',
    /* internal name: 'utility' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'utility',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/utility/index.vue'),
        /* no children */
      },
  _definePage_default_23
  )
    ],
  }
]
